import {BaseModel} from "@shared/models/base.model";
import {
  DocumentTemplateStatusEnum,
  DocumentTemplateType as BaseType,
  HasDocumentTemplateType
} from "@generated/graphql";
import {User} from "@modules/user/models/user.model";
import {File} from "@modules/file/models/file.model";
import {userFactory} from "@modules/user/factories/user.factory";
import {ServiceSupportedCountry} from "@modules/service/models/service-supported-country.model";
import {documentTemplateTypeFactory} from "@modules/document-template/factories/document-template-type.factory";
import {DocumentTemplateType} from "@modules/document-template/models/document-template-type.model";

export const placeValue = (value) => {
  return value ? value : '_______'
}

export const applyPlaceValue = (obj: any): any => {
  if (obj === null || obj === undefined) return placeValue('');

  if (typeof obj === 'object' && !Array.isArray(obj)) {

    return Object.fromEntries(
      Object.entries(obj).map(([key, value]) => [key, applyPlaceValue(value)])
    );
  }

  return placeValue(obj);
}

export const addAlphabetPrefix = (arr: string[]): string[] => {
  return arr.map((item, index) => `(${String.fromCharCode(97 + index)}) ${item}`);
}

export type HasDocumentTemplate = ServiceSupportedCountry

export class DocumentTemplate extends BaseModel implements BaseType {
  id: string;
  name: string;
  template: File;
  createdBy: User;
  status: DocumentTemplateStatusEnum;
  documentTemplateType: DocumentTemplateType
  _model: string;
  hasDocumentTemplate: HasDocumentTemplate

  constructor(state: BaseType) {
    super(state);

    this.createdBy = userFactory.tryCreating(state.createdBy)

    this.documentTemplateType = documentTemplateTypeFactory.tryCreating(state.documentTemplateType)
  }

  getModelName(): string {
    return DocumentTemplate.name;
  }

  statusColor () {
    switch (this.status) {
      case DocumentTemplateStatusEnum.Active:
        return 'success'
      case DocumentTemplateStatusEnum.Inactive:
        return 'error'
    }
  }
}
